export type PersistProjectMigrationIssueScope = 'project' | 'loadedProject' | 'state';

export type PersistProjectMigrationIssue = {
  scope: PersistProjectMigrationIssueScope;
  projectId?: string;
  projectName?: string;
  message: string;
};

export type PersistProjectMigrationReport = {
  partialFailures: PersistProjectMigrationIssue[];
  catastrophicFailure: boolean;
  backupCreated: boolean;
};

type MigrationReportListener = () => void;

let migrationReport: PersistProjectMigrationReport | null = null;
const migrationReportListeners = new Set<MigrationReportListener>();

const notifyMigrationReportListeners = () => {
  migrationReportListeners.forEach((listener) => listener());
};

export const subscribeToPersistProjectMigrationReport = (listener: MigrationReportListener) => {
  migrationReportListeners.add(listener);

  return () => {
    migrationReportListeners.delete(listener);
  };
};

export const getPersistProjectMigrationReportSnapshot = () => migrationReport;

export const setPersistProjectMigrationReport = (report: PersistProjectMigrationReport | null) => {
  migrationReport = report;
  notifyMigrationReportListeners();
};

/** Clears the report after the snackbar has been shown. */
export const clearPersistProjectMigrationReport = () => {
  if (migrationReport == null) {
    return;
  }

  migrationReport = null;
  notifyMigrationReportListeners();
};

export function hasPersistProjectMigrationIssues(report: PersistProjectMigrationReport | null): report is PersistProjectMigrationReport {
  if (!report) return false;
  return report.catastrophicFailure || report.partialFailures.length > 0;
}
